<template>
  <h-description
    :name="combination.itemName"
    :price="combination.price * quantity"
    :paid="paid"
  />
</template>

<script>
  import HDescription from './ItemDescription'

  export default {
    components: {
      HDescription,
    },

    props: {
      quantity: {
        required: true,
        type: Number,
      },
      combination: {
        required: true,
        type: Object,
      },
      paid: {
        required: false,
        type: Boolean,
        default: false,
      },
    },
  }
</script>
